import _extends from "@babel/runtime/helpers/esm/extends";
import { SuperDashboardCard } from "../../SuperDashboard";
import { Progress } from 'antd';
import React from 'react';
export var ResourceUsageStatistics = /*#__PURE__*/React.forwardRef(function (properties, ref) {
  var percent = Number((properties.data.volume / properties.data.capacity * 100).toFixed(2));
  return /*#__PURE__*/React.createElement(SuperDashboardCard, _extends({
    ref: ref
  }, properties, {
    bodyStyle: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '10px 0 20px 0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-flex'
    }
  }, /*#__PURE__*/React.createElement(Progress, {
    showInfo: false,
    size: 48,
    strokeWidth: 16,
    type: "circle",
    percent: percent
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      color: '#181A1D',
      fontSize: '20px',
      marginLeft: '12px',
      display: 'inline-flex',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      verticalAlign: 'middle'
    }
  }, percent, "%")), [{
    key: '当前',
    value: properties.data.volume
  }, {
    key: '全部',
    value: properties.data.capacity
  }].map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        flexFlow: 'nowrap',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        // marginTop: '8px',
        fontSize: '14px',
        color: '#707275',
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: '33%',
        marginRight: '4px',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
      }
    }, item.key), /*#__PURE__*/React.createElement("div", {
      style: {
        width: '66%',
        textAlign: 'right',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        color: '#181A1D'
      }
    }, item.value, " ", properties.dataUnit));
  }), properties.children);
});
ResourceUsageStatistics.isProCard = true;